var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSideBarMenuLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "zy8rl7vu1a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.275000 0 0 0 0 0.327941 0 0 0 0 0.500000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -11)",
    filter: "url(#zy8rl7vu1a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 17H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9.098L15 3.95V12",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5h-3a1 1 0 0 1-1-1v-3",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 7H4M11.5 9.5H4"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    strokeWidth: 0.8,
    x: 6,
    y: 12,
    width: 10,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.292 16.16v-.496h-1.2V13.2H7.5v2.96h1.792zm1.404.056c.56 0 1.076-.432 1.076-1.172 0-.748-.516-1.18-1.076-1.18s-1.076.432-1.076 1.18c0 .74.516 1.172 1.076 1.172zm0-.48c-.304 0-.476-.272-.476-.692 0-.424.172-.7.476-.7s.476.276.476.7c0 .42-.172.692-.476.692zm2.356 1.396c.748 0 1.216-.344 1.216-.796 0-.392-.292-.56-.832-.56h-.38c-.264 0-.352-.064-.352-.184 0-.088.032-.14.096-.192.096.032.2.052.288.052.48 0 .864-.256.864-.76a.564.564 0 0 0-.104-.34h.384v-.432h-.808a1.054 1.054 0 0 0-.336-.056c-.476 0-.904.284-.904.812 0 .26.144.472.296.584v.016c-.132.096-.248.252-.248.42 0 .184.088.3.204.376v.02c-.204.116-.32.276-.32.464 0 .396.408.576.936.576zm.036-2.044c-.196 0-.352-.148-.352-.412s.152-.412.352-.412c.2 0 .348.148.348.412s-.152.412-.348.412zm.052 1.672c-.328 0-.536-.108-.536-.296 0-.092.048-.18.148-.26.08.02.176.032.312.032h.272c.24 0 .372.04.372.2 0 .176-.232.324-.568.324z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSideBarMenuLog);
export default __webpack_public_path__ + "static/media/ico-side-bar-menu-log.0536893fb98bebbb1c2ffba3d9fa61f5.svg";
export { ForwardRef as ReactComponent };